import React from "react";
import { Redirect } from "react-router-dom";
import { getFirstAllowedRoute } from "../services/PermissionService";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AuthLockScreen from "../pages/Authentication/AuthLockScreen";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Pages Calendar
import Calendar from "../pages/Calendar/Calendar";

// Pages Component
import Chat from "../pages/Chat/Chat";

//Ecommerce Pages
import Products from "../pages/Ecommerce/Products";
import ProductDetail from "../pages/Ecommerce/ProductDetail";
import Orders from "../pages/Ecommerce/Orders";
import Customers from "../pages/Ecommerce/Customers";
import Cart from "../pages/Ecommerce/Cart";
import CheckOut from "../pages/Ecommerce/CheckOut";
import Shops from "../pages/Ecommerce/Shops";
import AddProduct from "../pages/Ecommerce/AddProduct";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ChartsKnob from "../pages/Charts/charts-knob";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";
import MapsVector from "../pages/Maps/MapsVector";

//Icons
import RemixIcons from "../pages/Icons/RemixIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign";
import DripiIcons from "../pages/Icons/DripiIcons";
import FontAwesome from "../pages/Icons/FontAwesome";

//Utility
import StarterPage from "../pages/Utility/StarterPage";
import Maintenance from "../pages/Utility/Maintenance";
import CommingSoon from "../pages/Utility/CommingSoon";
import Timeline from "../pages/Utility/Timeline";
import FAQs from "../pages/Utility/FAQs";
import Pricing from "../pages/Utility/Pricing";
import Error404 from "../pages/Utility/Error404";
import Error500 from "../pages/Utility/Error500";

// Forms
import FormElements from "../pages/Forms/FormElements";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";
import FormXeditable from "../pages/Forms/FormXeditable";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiSweetAlert from "../pages/Ui/UiSweetAlert";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";
import UiNotifications from "../pages/Ui/ui-notifications";
import UIRoundSlider from "../pages/Ui/UIRoundSlider";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";
import EditableTables from "../pages/Tables/EditableTables";

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Register1 from "../pages/AuthenticationInner/Register";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";

//Kanban Board
import KanbanBoard from "../pages/KanbanBoard/index";
import Breed from "../pages/Breed/breed";
import Room from "../pages/Room/room";
import Foodcuisine from "../pages/foodcuisine/index";
import FoodSettings from "../pages/FoodSettings/foodSettings";
import FoodAddOn from "../pages/foodAddOn/AddOn";
import Amenities from "../pages/Room/amenities";
import Food from "../pages/food/index";
import Table from "../pages/Table/table";
import TableBooking from "../pages/food/TableBooking";
import Attraction from "../pages/Attraction/attraction";
import Taxi from "../pages/Taxi/taxi";
import SMSNotificationList from "../pages/ManageNotification/manageNotification";
import AppVersionSettings from "../pages/AppVersionSettings/AppVersionSettings";
import RoomCancel from "../pages/Room/Roomcancellation";
import Booking from "../pages/Room/Booking";
import FoodOrder from "../pages/food/assignDboy";
import Notification from "../pages/Notification/notification";
import DeliveryBoy from "../pages/Users/index";
import User from "../pages/Users/user";
import ChatList from "../pages/Chat/chatlist";

// Team Management (ACM)
import TeamList from "../pages/Team/TeamList";

// Branch Management (Super Admin)
import BranchList from "../pages/Branch/BranchList";
import MasterCatalog from "../pages/MasterCatalog/MasterCatalog";

// Profile
import ProfilePage from "../pages/Profile/ProfilePage";

// Coupon Management
import CouponList from "../pages/Coupon/CouponList";
import CouponForm from "../pages/Coupon/CouponForm";

// Banner Management
import BannerList from "../pages/Banner/BannerList";
import BannerForm from "../pages/Banner/BannerForm";

// Transport Management
import TransportRequestList from "../pages/Transport/TransportRequestList";
import TransportRequestDetail from "../pages/Transport/TransportRequestDetail";
import TransportServices from "../pages/Transport/TransportServices";
import TransportDrivers from "../pages/Transport/TransportDrivers";
import VehicleTypes from "../pages/Transport/VehicleTypes";
import ServiceTiers from "../pages/Transport/ServiceTiers";
import TransportSettings from "../pages/Transport/TransportSettings";

// Room stock: numbered rooms + availability (ROOM module)
import RoomUnits from "../pages/RoomStock/RoomUnits";
import RoomAvailability from "../pages/RoomStock/RoomAvailability";

// Restaurants & bars (outlets, TABLE module)
import OutletList from "../pages/Outlets/OutletList";
import OutletForm from "../pages/Outlets/OutletForm";
import OutletDay from "../pages/Outlets/OutletDay";

// Cross-sell offers
import CrossSellRules from "../pages/CrossSell/CrossSellRules";
import CrossSellRuleForm from "../pages/CrossSell/CrossSellRuleForm";
import CrossSellReport from "../pages/CrossSell/CrossSellReport";

// Loyalty Program
import LoyaltyAccounts from "../pages/Loyalty/LoyaltyAccounts";
import LoyaltyAccountDetail from "../pages/Loyalty/LoyaltyAccountDetail";
import LoyaltySettings from "../pages/Loyalty/LoyaltySettings";

// Payments & Transactions
import MpesaTransactions from "../pages/Payments/MpesaTransactions";

// Analytics & Activity Logs
import AnalyticsDashboard from "../pages/Analytics/AnalyticsDashboard";
import RevenueReports from "../pages/Analytics/RevenueReports";
import FoodAnalytics from "../pages/Analytics/FoodAnalytics";
import RoomAnalytics from "../pages/Analytics/RoomAnalytics";
import TableAnalytics from "../pages/Analytics/TableAnalytics";
import TransportAnalytics from "../pages/Analytics/TransportAnalytics";
import CouponAnalytics from "../pages/Analytics/CouponAnalytics";
import UserAnalytics from "../pages/Analytics/UserAnalytics";
import ActivityLogList from "../pages/ActivityLogs/ActivityLogList";

// Dynamic redirect component - redirects to first allowed route based on permissions
const DefaultRedirect = () => {
  const firstRoute = getFirstAllowedRoute();
  return <Redirect to={firstRoute} />;
};

const authProtectedRoutes = [
  //Kanban Board
  { path: "/RoomType", component: KanbanBoard },

  // Tables

  { path: "/AmenityType", component: Breed },
  { path: "/Amenities", component: Amenities },
  // Ui
  { path: "/Room", component: Room },
  { path: "/Foodcuisine", component: Foodcuisine },
  { path: "/FoodSettings", component: FoodSettings },
  { path: "/Food", component: Food },
  { path: "/FoodAddOn", component: FoodAddOn },
  { path: "/Table", component: Table },
  { path: "/TableBooking", component: TableBooking },
  { path: "/Attraction", component: Attraction },
  { path: "/Taxi", component: Taxi },
  { path: "/ManageNotification", component: SMSNotificationList },
  { path: "/AppVersionSettings", component: AppVersionSettings },
  { path: "/RoomCancel", component: RoomCancel },
  { path: "/Booking", component: Booking },
  { path: "/FoodOrder", component: FoodOrder },
  { path: "/DeliveryBoy", component: DeliveryBoy },
  { path: "/User", component: User },

  { path: "/Notification", component: Notification },

  { path: "/ChatList", component: ChatList },

  // Coupon Management (COUPON module) - specific routes first
  { path: "/coupon/create", component: CouponForm },
  { path: "/coupon/edit/:id", component: CouponForm },
  { path: "/coupon", component: CouponList },

  // Banner Management (BANNER module) - specific routes first
  { path: "/banner/create", component: BannerForm },
  { path: "/banner/edit/:id", component: BannerForm },
  { path: "/banner", component: BannerList },

  // Transport Management (TRANSPORT module) - specific routes first
  { path: "/transport/request/:id", component: TransportRequestDetail },
  { path: "/transport/requests", component: TransportRequestList },
  { path: "/transport/services", component: TransportServices },
  { path: "/transport/drivers", component: TransportDrivers },
  { path: "/transport/vehicle-types", component: VehicleTypes },
  { path: "/transport/service-tiers", component: ServiceTiers },
  { path: "/transport/settings", component: TransportSettings },

  // Room stock (ROOM module)
  { path: "/rooms/units", component: RoomUnits },
  { path: "/rooms/availability", component: RoomAvailability },

  // Restaurants & bars (TABLE module) - specific routes first
  { path: "/outlets/new", component: OutletForm },
  { path: "/outlets/edit/:id", component: OutletForm },
  { path: "/outlets/:id/bookings", component: OutletDay },
  { path: "/outlets", component: OutletList },

  // Cross-sell offers (CROSSSELL module) - specific routes first
  { path: "/crosssell/report", component: CrossSellReport },
  { path: "/crosssell/new", component: CrossSellRuleForm },
  { path: "/crosssell/edit/:id", component: CrossSellRuleForm },
  { path: "/crosssell", component: CrossSellRules },

  // Loyalty Program (LOYALTY module) - specific routes first
  { path: "/loyalty/settings", component: LoyaltySettings },
  { path: "/loyalty/accounts/:userId", component: LoyaltyAccountDetail },
  { path: "/loyalty/accounts", component: LoyaltyAccounts },

  // Payments & Transactions (PAYMENTS module)
  { path: "/payments/transactions", component: MpesaTransactions },

  // Team Management (ACM - Super Admin Only)
  { path: "/team", component: TeamList },

  // Branch Management (Super Admin Only) - specific routes first
  { path: "/master-catalog", component: MasterCatalog },
  { path: "/branches", component: BranchList },

  // Profile (accessible by all logged-in users)
  { path: "/profile", component: ProfilePage },

  // Analytics & Activity Logs
  { path: "/analytics/revenue", component: RevenueReports },
  { path: "/analytics/food", component: FoodAnalytics },
  { path: "/analytics/room", component: RoomAnalytics },
  { path: "/analytics/table", component: TableAnalytics },
  { path: "/analytics/transport", component: TransportAnalytics },
  { path: "/analytics/coupon", component: CouponAnalytics },
  { path: "/analytics/users", component: UserAnalytics },
  { path: "/analytics", component: AnalyticsDashboard },
  { path: "/activity-logs", component: ActivityLogList },

  // Forms
  { path: "/form-elements", component: FormElements },
  { path: "/form-advanced", component: FormAdvanced },
  { path: "/form-editors", component: FormEditors },
  { path: "/form-mask", component: FormMask },
  { path: "/form-uploads", component: FormUpload },
  { path: "/form-wizard", component: FormWizard },
  { path: "/form-validation", component: FormValidations },
  { path: "/form-xeditable", component: FormXeditable },

  //Utility

  //Charts
  { path: "/charts-apex", component: ChartApex },
  { path: "/charts-chartjs", component: ChartjsChart },
  { path: "/charts-sparkline", component: SparklineChart },
  { path: "/charts-knob", component: ChartsKnob },

  //Email
  { path: "/email-inbox", component: EmailInbox },
  { path: "/email-read", component: EmailRead },

  //Ecommerce

  //chat
  { path: "/RoomHospitalityService", component: Chat },

  //calendar
  { path: "/RoomFeature", component: Calendar },

  { path: "/dashboard", component: Dashboard },

  // this route should be at the end of all other routes
  // Redirects to first allowed route based on user's permissions
  { path: "/", exact: true, component: DefaultRedirect },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/auth-lock-screen", component: AuthLockScreen },

  // Authentication Inner
  { path: "/auth-login", component: Login1 },
  { path: "/auth-register", component: Register1 },
  { path: "/auth-recoverpw", component: ForgetPwd1 },

  { path: "/pages-maintenance", component: Maintenance },
  { path: "/pages-comingsoon", component: CommingSoon },
  { path: "/pages-404", component: Error404 },
  { path: "/pages-500", component: Error500 },
];

export { authProtectedRoutes, publicRoutes };
